<template>
  <validation-observer ref="form">
    <div class="mt-2">
      <div class="d-flex">
        <i class="fas fa-list text-orange mr-2 mt-1"></i>
        <p class="font-weight-normal font-18">
          Asignar Nivel de Prioridad
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-5">
        <validation-provider v-slot="{ errors }" slim rules="required">
          <label class="data-label">Nivel de Prioridad:</label>
          <custom-drop-down
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="Favor de seleccionar el nivel de prioridad."
            v-model="model.priorityLevel"
            :error="errors[0]"
            :options="options"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-end mt-4">
        <action-button
          type="button"
          :text="isReadOnly ? 'Cerrar' : 'Cancelar'"
          i="fas fa-times-circle"
          variant="outline-danger"
          :class="{ 'mr-2': !isReadOnly }"
          @click="$emit('cancel')"
        />
        <action-button
          v-if="!isReadOnly"
          type="button"
          text="Guardar"
          i="fas fa-save"
          variant="success"
          @click="save"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';

export default {
  name: 'AssignPriority',
  components: {
    CustomDropDown,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    model: { priorityLevel: null },
  }),
  mounted() {
    if (this.value) this.model = { ...this.value };
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;
      this.$emit('save', this.model);
    },
  },
};
</script>
